import { t } from "i18next";
import type { JSX } from "react";
import { Button } from "../button";

const RecorderControls = ({
  status,
  onPause,
  onResume,
  onStopAndSave,
  pauseEnabled = true,
}: {
  status: string;
  onPause: () => void;
  onResume: () => void;
  onStopAndSave: () => void;
  /** Offer Pause (live OpenAI hides it); Resume shows whenever paused. */
  pauseEnabled?: boolean;
}): JSX.Element => {
  return (
    <div className="w-full flex gap-4 justify-center items-center">
      {pauseEnabled && status === "recording" ? (
        <Button
          aria-label={t("components.recorderControls.pauseButton")}
          className="w-[150px] font-bold"
          size="lg"
          onClick={onPause}
        >
          {t("components.recorderControls.pauseButton")}
        </Button>
      ) : status === "paused" ? (
        // Always offered when paused, also where Pause is not (the
        // recording can still be paused by an interruption or Stop).
        <Button
          aria-label={t("components.recorderControls.resumeButton")}
          className="w-[150px] font-bold"
          size="lg"
          onClick={onResume}
        >
          {t("components.recorderControls.resumeButton")}
        </Button>
      ) : null}
      <Button
        aria-label={t("components.recorderControls.stopAndSaveButton")}
        className="w-[150px] font-bold"
        size="lg"
        variant={"destructive"}
        onClick={onStopAndSave}
      >
        {t("components.recorderControls.stopAndSaveButton")}
      </Button>
    </div>
  );
};

export default RecorderControls;
